module.exports = __webpack_public_path__ + "media/images/kds/refunded-aa163ae5215dd4eeaf4cb362ed5fc1ec.png";